<body id="image-container" [ngStyle]="{'background-image' : 'url(' + bgImgURL +
	')'}">
	<nb-card class="card" style="border-radius: 10px; ">
		<nb-card-body>
			<div class="row">
				<div class="col-12" style="text-align: center;">
					<a class="cLink"  href="http://www.kragworks.com">
						<!-- <cl-image public-id="{{logoImgURL}}" style="width: 65%;">
						</cl-image> -->
						<advanced-image class="advanceImg" [cldImg]="logoImgURL" style="width: 65%"></advanced-image>
						<!-- <advanced-image cldImg="{{logoImgURL}}" style="width: 65%;"></advanced-image> -->
					</a>
				</div>
				<!-- <div class="col-12 text-center mt-3">
					<h5 style="font-family: Arial, Helvetica, sans-serif;
							color: white; white-space: nowrap;">WEB PORTAL
					</h5>
				</div> -->
				<div class="col-12 mt-3 mb-3 text-center">
					<m-login></m-login>
				</div>
			</div>
		</nb-card-body>
		<nb-card-footer>
			<div class="row">
				<div class="col-12" style="text-align: center;">
					<a style="text-align: right;" href="http://www.kragworks.com">
						<!-- <cl-image public-id="Login/kragworks_logo" style="width: 65%;">
						</cl-image> -->
						<advanced-image class="footerLogo" [cldImg]="footerLogo" style="width: 65%;"></advanced-image>
					</a>
				</div>
			</div>

			<div class="row">
				<div class="col text-center mt-1">
					<p style="color: white; font-size: 80%;">
						©{{today | date:'yyyy'}} </p>
				</div>
			</div>

		</nb-card-footer>
	</nb-card>

	<div id="footerdiv">
		<div class="row">
			<div class="col" style="text-align: left;">
			</div>
			<div class="col" style="text-align: center;">
			</div>

			<div class="col" style="padding-right: 0px; white-space: nowrap;">
				<p class="text-end" style="color: white; font-size: 80%; margin-bottom:
					0px; margin-top: 30px;">
					{{today | date:'yyyy'}} Kragworks Ag Solutions </p>
				<!-- <p class="text-end" style="color: white; font-size: 80%; margin-bottom:
					0px; margin-top: 30px;">
					{{hostname}}</p>
					<p class="text-end" style="color: white; font-size: 80%; margin-bottom:
					0px; margin-top: 30px;">
					{{host}}</p> -->
			</div>
		</div>
	</div>
</body>